import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const fetchMeetingTypes = (setMeetingTypes: Function, setIsLoading: Function, language: string) => {
  setIsLoading(true);
  ApiService.get("meetings/types")
    .then((response) => setMeetingTypes(response.data.meeting_types))
    .catch((err) => {
      console.error("Error fetching meeting types:", err);
      alert(translate(language, "PAGES.MEETINGS.ERROR.FETCH_MEETING_TYPES"));
    })
    .finally(() => setIsLoading(false));
};

export const generateRemoteUrl = (startDate: string | null, endDate: string | null, typeIds?: string[]) => {
  const filters = ["order=desc"];
  if (startDate) {
    filters.push(`start_date=${new Date(startDate).toISOString()}`);
  }
  if (endDate) {
    const end = new Date(endDate);
    end.setHours(23, 59, 59, 999);
    filters.push(`end_date=${end.toISOString()}`);
  }
  if (typeIds?.length) {
    filters.push(`type_ids=${typeIds.join(",")}`);
  }

  return `meetings/workload${filters.length ? `?${filters.join("&")}` : ""}`;
};

export const fetchMeetingsWorkload = (
  path: string,
  language: string,
  setWorkload: Function,
  setIsLoading: Function
) => {
  setIsLoading(true);

  ApiService.get(path)
    .then((response) =>
      setWorkload(
        response.data.meetings_workload.map((element: any, index: number) => ({
          ...element,
          index: index + 1,
        }))
      )
    )
    .catch((err) => {
      console.error("Error fetching meetings workload:", err);
      alert(translate(language, "PAGES.MEETINGS_WORKLOAD.ERROR.FETCH"));
    })
    .finally(() => setIsLoading(false));
};
